// Founder P0 2026-09 — ONE authoritative "operational active collaborator"
// rule for client-portal selectors. Employment status ≠ platform permissions:
// a Client Admin can also be an active collaborator (e.g. CFO).
export const isActiveCollaborator = (u) =>
  (!u?.role || u.role === 'evaluated' || u.role === 'client_admin')
  && !u?.external_candidate && !u?.recruitment_candidate
  && !['inactive', 'disabled'].includes(u?.status)
  && (u?.employment_status || 'active') !== 'former';
